__turbopack_context__.v({
  "active": "Q-pilW_active",
  "homeLink": "Q-pilW_homeLink",
  "leftColumn": "Q-pilW_leftColumn",
  "link": "Q-pilW_link",
  "logo": "Q-pilW_logo",
  "logoImage": "Q-pilW_logoImage",
  "logoText": "Q-pilW_logoText",
  "mainNav": "Q-pilW_mainNav",
  "navbar": "Q-pilW_navbar",
  "rightColumn": "Q-pilW_rightColumn",
  "sidebar": "Q-pilW_sidebar",
  "sidebarBackdrop": "Q-pilW_sidebarBackdrop",
  "sidebarToggle": "Q-pilW_sidebarToggle",
  "signin": "Q-pilW_signin",
});
